//
// Definitions (Poses)
//
import React from 'react'
import posed from 'react-pose'

export const FadeInBox = posed.div({
       visible: {
               opacity: 1,
       },
       hidden: {
               opacity: 0,
       }
})

export const DraggableItem = posed.div({
    draggable: true,
    dragBounds: { left: '-40%', right: '40%' },
	init: { zIndex: 1 },
	drag: { zIndex: 10 },
	flip: { transition: positionFlipTransition },
})

export const FixedItem = posed.div({
    draggable: false,
	flip: { transition: positionFlipTransition },
})

type PositionFlipTransitionProps = {
	key: string
	poseSuppressFlip?: boolean
}

function positionFlipTransition(props: PositionFlipTransitionProps) {
	// Never swap between separate posed component types to disable FLIP: doing so
	// remounts the tile, can replay its entrance animation, and can break dragging.
	// A transition prop keeps component identity and Pose's measurements intact.
	if (props.poseSuppressFlip) return false

	// These values mirror Popmotion Pose's defaults. Defining them explicitly lets
	// us turn selected FLIPs off without changing the feel of normal tile shuffling.
	if (props.key === 'x' || props.key === 'y') {
		return {
			type: 'spring',
			stiffness: 500,
			damping: 25,
			restDelta: 0.5,
			restSpeed: 10,
		}
	}
	if (props.key === 'scaleX' || props.key === 'scaleY') {
		return { type: 'spring', stiffness: 700, damping: 35 }
	}
	return { type: 'tween' }
}

export const DraggableItemPlayer = posed.div({
	draggable: true,
	dragBounds: { left: '-20%', right: '20%' },
})

type PositionPreferenceProps = {
	className?: string
}

export const PositionPreference = (props: React.PropsWithChildren<PositionPreferenceProps>) => {
	return (
		<div className={`flat-position-preference posed-element ${props.className || ''}`}>
			{props.children}
		</div>
	)
}
